import { defineComponent as _defineComponent } from 'vue'

const __default__ = {}

import device from '@@/bits/device'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzCheckBox',
  props: {
    darkMode: { type: [Boolean, String], default: 'auto' },
    dir: { default: 'auto' },
    value: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    label: { default: '' }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'input', value: boolean, event: Event): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { darkMode: boolean | 'auto', dir: 'ltr' | 'rtl' | 'auto', value: boolean, disabled: boolean, label: string }





const disabledTextClasses = computed((): Record<string, boolean> => {
  return {
    'text-dark-text-400': props.darkMode === false,
    'text-light-text-400': props.darkMode === true,
    'text-dark-text-400 dark:text-light-text-400': props.darkMode === 'auto',
  }
})

const disabledSvgClasses = computed((): Record<string, boolean> => {
  return {
    'text-modal-overlay-grape': props.darkMode === false,
    'text-modal-overlay-canary': props.darkMode === true,
    'text-modal-overlay-grape dark:text-modal-overlay-canary': props.darkMode === 'auto',
  }
})

const isIOS = device.ios
const isMacOSSafari = device.mac && device.safari

const viewBoxForBrowsersOnAppleDevice = computed((): string =>
  props.dir === 'rtl' ? '-0.32 0.3 16 16' : '0.32 0.3 16 16',
)

const viewBox = computed((): string => (isIOS || isMacOSSafari ? viewBoxForBrowsersOnAppleDevice.value : '0 0 16 16'))

const onChange = (e: Event): void => {
  if (props.disabled) return
  emit('input', props.value, e)
}

return { __sfc: true,props, emit, disabledTextClasses, disabledSvgClasses, isIOS, isMacOSSafari, viewBoxForBrowsersOnAppleDevice, viewBox, onChange }
}

})